module.exports = "/fonts/vendor/@flaticon/flaticon-uicons/css/uicons-bold-rounded-UTQQXXF3.woff?4a23c5df30d392803f73b5c97bc39a0d";